import '../../global.css'

import { MainHeader } from "../../components/Header";
import { Panel } from "../../pages/Home/Panel";
import { Faq } from "../../components/FAQ";
import { Footer } from '../../components/Footer';
import { Contato } from './Contato';

export default function App() {
  return (
    <>
    <MainHeader />
    <Panel />
    <Contato />
    <Faq />
    <Footer />
    </>
  );
}